















import { Component, Prop, Vue } from 'vue-property-decorator';
// @ts-ignore
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';
@Component({
  name: 'lb-collapse-menu',
  components: {
    CollapseTransition
  }
})
export default class extends Vue {
  @Prop({type: Boolean, default: false}) private visible!: boolean;

  private localVisible: boolean = this.visible;

  private handleClickTitle() {
    this.localVisible = !this.localVisible;
  }

  // @Watch('visible')
  // private onVisibleChange(visible: boolean) {
  //   this.localVisible = visible;
  // }
  //
  // @Watch('localVisible')
  // private onLocalVisibleChange(visible: boolean) {
  //   this.$emit('update:visible', visible);
  // }
}
